var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00977,
    y: 4.74854,
    width: 14.5027,
    height: 14.5027,
    rx: 3.375,
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5434 12.1064L16.5431 10.8431C16.543 10.4714 16.7265 10.1237 17.0335 9.91398L20.2401 7.72319C20.9868 7.21304 21.9997 7.74776 21.9997 8.65209V15.3476C21.9997 16.2519 20.9868 16.7866 20.2401 16.2765L17.0335 14.0857C16.7266 13.876 16.543 13.5283 16.5431 13.1565L16.5434 12.1064Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15039 12H11.3706",
    stroke: "#3C3C3C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26074 14.1104L9.26074 9.89019",
    stroke: "#3C3C3C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/Video_Call.0574aff8f89dd57810d86e289542c706.svg";
export { ForwardRef as ReactComponent };